<ng-container *transloco="let t;">
  <form (submit)="onSubmit()" novalidate *ngIf="template !== null">

    <div class="p-grid">
      <div class="p-col-6">
        <h2>{{ t('common.labels.todos') }}</h2>
      </div>
      <div class="p-col-6 p-text-right" *ngIf="inEdit !== true && inOrdering !== true">
        <button withRight="admin.template.edit" pButton (click)="onEdit()" type="button" label="{{ t('common.labels.edit') }}" icon="pi pi-pencil" class="p-button-sm p-mb-2 autofocus"></button>
        <button *ngIf="items.length > 0" pButton type="button" (click)="menu.toggle($event)" icon="pi pi-bars" class="p-button-outlined p-button-secondary p-button-sm p-mb-2 p-ml-2" aria-label="{{ t('common.labels.more_functions') }}"></button>
        <p-menu #menu [popup]="true" [model]="items"></p-menu>
        </div>
      <div class="p-col-6 p-text-right" *ngIf="inEdit === true || inOrdering === true">
        <app-form-buttons [submitting]="submitting" (cancelled)="onCancel()"></app-form-buttons>
      </div>
    </div>

    <p-table
      [value]="todos"
      [reorderableColumns]="inOrdering === true"
      (onRowReorder)="onRowReorder($event)"
    >

      <ng-template pTemplate="colgroup">
        <colgroup>
            <col style="width: 3rem" *ngIf="inOrdering === true">
            <col>
            <col style="width:50px">
            <col style="width:50px">
            <col style="width:120px">
        </colgroup>
      </ng-template>

      <ng-template pTemplate="header">
        <tr>
          <th *ngIf="inOrdering === true"></th>
          <th>{{ t('common.labels.todo') }}</th>
          <th>{{ t('common.labels.onsite') }}</th>
          <th>{{ t('common.labels.virtual') }}</th>
          <th></th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-todo let-index="rowIndex">
        <tr tabindex="0" [pReorderableRow]="index">
          <td *ngIf="inOrdering === true">
            <span class="pi pi-bars" pReorderableRowHandle></span>
          </td>
          <td>
            <ng-container *ngFor="let language of languages">
              <div class="p-grid">
                <div class="p-col-fixed" style="width: 40px;">{{ language.key }}:</div>
                <div class="p-col">
                  <app-form-control [cid]="language.key + todo.id" [control]="todo.controls[language.key]" [type]="'input'" [edit]="inEdit" [basevalue]="todo.name[language.key]" [noMargin]="true" [showLabel]="false"></app-form-control>
                </div>
              </div>
            </ng-container>
          </td>
          <td>
            <app-form-control [cid]="'onsite' + todo.id" [control]="todo.controls.onsite" [type]="'checkbox'" [edit]="inEdit" [basevalue]="todo.onsite" [noMargin]="true" [showLabel]="false"></app-form-control>
          </td>
          <td>
            <app-form-control [cid]="'virtual' + todo.id" [control]="todo.controls.virtual" [type]="'checkbox'" [edit]="inEdit" [basevalue]="todo.virtual" [noMargin]="true" [showLabel]="false"></app-form-control>
          </td>
          <td class="p-text-right">
            <ng-container *ngIf="inEdit">
              <button pButton (click)="deleteTodo(todo)" type="button" icon="pi pi-trash" class="p-button-outlined danger-button"></button>
            </ng-container>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td class="no-data" colspan="5">{{ t('common.labels.no_data') }}</td>
        </tr>
      </ng-template>

    </p-table>

    <p *ngIf="inEdit" class="p-text-right p-mt-4">
      <button pButton (click)="addTodo()" type="button" icon="pi pi-plus" [label]="t('common.labels.add_todo')" class="p-mr-3"></button>
    </p>

  </form>

  <app-inherit-dialog
    [title]="t('common.labels.save')"
    [mode]="'template'"
    [(visible)]="inheritVisible"
    (okClicked)="saveTodos($event)"
  ></app-inherit-dialog>

</ng-container>
